module.exports = __webpack_public_path__ + "img/bf-hero-mobile.8ecc9f8d.jpg";